import { useUrlHistory } from '@aibees/elephant/hooks';
import { Icon } from '@aibees/shared/components';
import { useUnMount } from '@aibees/shared/hooks';
import { classnames } from '@aibees/shared/utils';
import { Box, IconButton, Paper, Typography } from '@mui/material';
import { memo } from 'react';
import * as SX from './sx';
import type { SearchLayoutHeaderTitleProps as Props } from './types';

export const SearchLayoutHeaderTitle = memo(({ className }: Props) => {
  const { current, history, redo, undo, reset } = useUrlHistory();
  const undoEnabled = history?.length && current !== 0;
  const redoEnabled =
    history?.length > 1 && current < (history?.length ?? 0) - 1;

  useUnMount(() => reset && reset());

  return (
    <Box
      className={classnames('SearchLayoutHeaderTitle', className)}
      display={'flex'}
      flexDirection={'row'}
      alignItems={'center'}
      gap={1}
    >
      <Typography variant="body3" fontWeight={700} color={'grey.800'}>
        Filters
      </Typography>
      <Paper>
        <IconButton
          size="small"
          onClick={() => {
            if (undoEnabled) undo();
          }}
          disabled={!undoEnabled}
          aria-label="Previous filters"
        >
          <Icon name={'reply'} size={18} />
        </IconButton>
        <IconButton
          size="small"
          onClick={() => {
            if (redoEnabled) redo();
          }}
          disabled={!redoEnabled}
          aria-label="Next filters"
        >
          <Icon name={'reply'} size={18} sxx={SX.rotate} />
        </IconButton>
      </Paper>
    </Box>
  );
});

SearchLayoutHeaderTitle.displayName = 'SearchLayoutHeaderTitle';
